"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZappAdjustToken = void 0;
var ZappEventName_1 = require("./ZappEventName");
exports.ZappAdjustToken = (_a = {},
    _a[ZappEventName_1.ZappEventName.ADDED_ADDRESS] = "5pncg0",
    _a[ZappEventName_1.ZappEventName.ADDED_ADDRESS_OUT_OF_AREA] = "yrkenm",
    _a[ZappEventName_1.ZappEventName.ADDED_PRODUCT_TO_CART] = "9xkuyo",
    _a[ZappEventName_1.ZappEventName.AUTHORIZED_APP_TRACKING] = "zhfbwz",
    _a[ZappEventName_1.ZappEventName.CLOSED_APP] = "m1ezc4",
    _a[ZappEventName_1.ZappEventName.CHANGED_APP_STATE] = "h3ecg1",
    _a[ZappEventName_1.ZappEventName.CLICKED_BANNER] = "w456mb",
    _a[ZappEventName_1.ZappEventName.CLICKED_GO_TO_DIFFERENT_ISSUE_FEEDBACK] = "bx7gij",
    _a[ZappEventName_1.ZappEventName.CLICKED_GO_TO_HOME] = "krve94",
    _a[ZappEventName_1.ZappEventName.CLICKED_GO_TO_HELP_CENTER] = "4qpn8g",
    _a[ZappEventName_1.ZappEventName.CLICKED_SUBMIT_ADDITIONAL_FEEDBACK] = "v30qm5",
    _a[ZappEventName_1.ZappEventName.CLICKED_COPY_REFERRAL_CODE] = "2jkbs2",
    _a[ZappEventName_1.ZappEventName.CLICKED_REORDER_PRODUCTS] = "na0szi",
    _a[ZappEventName_1.ZappEventName.CLICKED_SHARE_REFERRAL_CODE] = "1i4igb",
    _a[ZappEventName_1.ZappEventName.CLICKED_SHARE_REFERRAL_QRCODE] = "qjdyu7",
    _a[ZappEventName_1.ZappEventName.CLICKED_TRENDING_SEARCH_QUERY] = "ggltah",
    _a[ZappEventName_1.ZappEventName.CONFIRMED_PUSH_PROMPT] = "hni0tc",
    _a[ZappEventName_1.ZappEventName.CONFIRMED_PUSH_PROMPT_ON_ORDER] = "lii25g",
    _a[ZappEventName_1.ZappEventName.CONFIRMED_RESTRICTION_MODAL] = "bitc4e",
    _a[ZappEventName_1.ZappEventName.CONFIRMED_WAITING_CUSTOMER] = "2knatn",
    _a[ZappEventName_1.ZappEventName.DELETED_ADDRESS] = "69v9ys",
    _a[ZappEventName_1.ZappEventName.DENIED_APP_TRACKING] = "ggqqlg",
    _a[ZappEventName_1.ZappEventName.EDITED_ADDRESS] = "hr0pw2",
    _a[ZappEventName_1.ZappEventName.GO_BACK_TO_PREVIOUS_MODAL] = "bk2juy",
    _a[ZappEventName_1.ZappEventName.OPENED_ADDITIONAL_COMMENTS_MODAL] = "61qgsg",
    _a[ZappEventName_1.ZappEventName.OPENED_APP] = "y1e17v",
    _a[ZappEventName_1.ZappEventName.OPENED_APP_RATING_DIALOG] = "oucoif",
    _a[ZappEventName_1.ZappEventName.OPENED_APP_FROM_SHARE_PRODUCT] = "memieq",
    _a[ZappEventName_1.ZappEventName.OPENED_BASKET] = "da9vl7",
    _a[ZappEventName_1.ZappEventName.OPENED_BASKET_SUMMARY] = "lyppj0",
    _a[ZappEventName_1.ZappEventName.OPENED_CATEGORY] = "rgpchm",
    _a[ZappEventName_1.ZappEventName.OPENED_CREDIT_LOGS] = "wa8g0t",
    _a[ZappEventName_1.ZappEventName.OPENED_CREDIT_MODAL] = "h3u4sr",
    _a[ZappEventName_1.ZappEventName.OPENED_DOES_NOT_QUALIFY_FOR_CREDIT_ISSUE_IS_NOT_URGENT_MODAL] = "ur0zil",
    _a[ZappEventName_1.ZappEventName.OPENED_DOES_NOT_QUALIFY_FOR_CREDIT_ISSUE_IS_URGENT_MODAL] = "9wd3l1",
    _a[ZappEventName_1.ZappEventName.OPENED_DIFFERENT_ISSUE_FEEDBACK_MODAL] = "sporha",
    _a[ZappEventName_1.ZappEventName.OPENED_HELP_CENTER] = "gj6rwy",
    _a[ZappEventName_1.ZappEventName.OPENED_HELP_CHAT] = "s22632",
    _a[ZappEventName_1.ZappEventName.OPENED_HELP_CALL] = "nyzzb0",
    _a[ZappEventName_1.ZappEventName.OPENED_HELP_FAQ] = "iat55f",
    _a[ZappEventName_1.ZappEventName.OPENED_HOME] = "16qk70",
    _a[ZappEventName_1.ZappEventName.OPENED_LIVE_TRACKING] = "bmhp9y",
    _a[ZappEventName_1.ZappEventName.OPENED_MENU] = "dkrlzn",
    _a[ZappEventName_1.ZappEventName.OPENED_MISSING_ITEM_MODAL] = "73a64i",
    _a[ZappEventName_1.ZappEventName.OPENED_NEGATIVE_FEEDBACK_MODAL] = "vaa691",
    _a[ZappEventName_1.ZappEventName.OPENED_ORDER] = "x5rd8i",
    _a[ZappEventName_1.ZappEventName.OPENED_ORDER_RATING_MODAL] = "lp9gc0",
    _a[ZappEventName_1.ZappEventName.OPENED_ORDERED_PRODUCTS_LIST] = "wonop3",
    _a[ZappEventName_1.ZappEventName.OPENED_POSITIVE_FEEDBACK_MODAL] = "l1erv3",
    _a[ZappEventName_1.ZappEventName.OPENED_PRODUCT] = "xsjghk",
    _a[ZappEventName_1.ZappEventName.OPENED_PRODUCT_ZOOM] = "et8z4i",
    _a[ZappEventName_1.ZappEventName.OPENED_PUSH_PROMPT] = "tqjhds",
    _a[ZappEventName_1.ZappEventName.OPENED_PUSH_PROMPT_ON_ORDER] = "rg4qkf",
    _a[ZappEventName_1.ZappEventName.OPENED_QUALIFIES_FOR_CREDIT_MODAL] = "ed7dy6",
    _a[ZappEventName_1.ZappEventName.OPENED_QUALITY_ISSUE_MODAL] = "hywfyg",
    _a[ZappEventName_1.ZappEventName.OPENED_REFERRAL] = "x66mux",
    _a[ZappEventName_1.ZappEventName.OPENED_REFERRAL_FROM_DEEP_LINK] = "cufv27",
    _a[ZappEventName_1.ZappEventName.OPENED_RESTRICTION_MODAL] = "8lj915",
    _a[ZappEventName_1.ZappEventName.OPENED_RIDER_TIPS] = "pj6aad",
    _a[ZappEventName_1.ZappEventName.OPENED_RIDER_TIPS_MODAL] = "8l89na",
    _a[ZappEventName_1.ZappEventName.OPENED_WAITING_CUSTOMER] = "4lsbdk",
    _a[ZappEventName_1.ZappEventName.PURCHASE_FAILED] = "lbgr65",
    _a[ZappEventName_1.ZappEventName.PURCHASE_FIRST_SUCCESSFUL] = "1uanug",
    _a[ZappEventName_1.ZappEventName.PURCHASE_SUCCESSFUL] = "18x9yl",
    _a[ZappEventName_1.ZappEventName.PRODUCT_PINCH_TO_ZOOM] = "929346",
    _a[ZappEventName_1.ZappEventName.REJECTED_ADDITIONAL_COMMENTS_MODAL] = "e7jcpj",
    _a[ZappEventName_1.ZappEventName.REJECTED_MISSING_ITEM_MODAL] = "b9n4dd",
    _a[ZappEventName_1.ZappEventName.REJECTED_NEGATIVE_FEEDBACK_MODAL] = "pqzs6t",
    _a[ZappEventName_1.ZappEventName.REJECTED_ORDER_RATING_MODAL] = "ntdzwv",
    _a[ZappEventName_1.ZappEventName.REJECTED_POSITIVE_FEEDBACK_MODAL] = "dz9qfb",
    _a[ZappEventName_1.ZappEventName.REJECTED_PUSH_PROMPT] = "h3e44e",
    _a[ZappEventName_1.ZappEventName.REJECTED_PUSH_PROMPT_ON_ORDER] = "9np0zb",
    _a[ZappEventName_1.ZappEventName.REJECTED_QUALITY_ISSUE_MODAL] = "7zv8wb",
    _a[ZappEventName_1.ZappEventName.REJECTED_RESTRCICTION_MODAL] = "g99lkd",
    _a[ZappEventName_1.ZappEventName.REJECTED_RIDER_TIPS] = "n6ikis",
    _a[ZappEventName_1.ZappEventName.REJECTED_RIDER_TIPS_MODAL] = "6h3yzj",
    _a[ZappEventName_1.ZappEventName.REMOVED_PRODUCT_FROM_CART] = "qcyhla",
    _a[ZappEventName_1.ZappEventName.REPORT_AN_ISSUE] = "zcybv2",
    _a[ZappEventName_1.ZappEventName.SKIPPED_RIDER_TIPS_MODAL] = "7hhw7g",
    _a[ZappEventName_1.ZappEventName.SIGNED_IN] = "40ac6t",
    _a[ZappEventName_1.ZappEventName.SIGNED_OUT] = "4mg1vl",
    _a[ZappEventName_1.ZappEventName.SIGNED_UP] = "v8z4lo",
    _a[ZappEventName_1.ZappEventName.SIGNED_UP_WITH_REFERRAL] = "v2w0f2",
    _a[ZappEventName_1.ZappEventName.SHARE_BUTTON_CLICKED] = "yt9xxx",
    _a[ZappEventName_1.ZappEventName.STARTED_SEARCH] = "6uy7h4",
    _a[ZappEventName_1.ZappEventName.COMPLETED_SEARCH] = "8od1a0",
    _a[ZappEventName_1.ZappEventName.ENDED_SEARCH_SESSION] = "ftkpxn",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_ADDITIONAL_COMMENTS_MODAL] = "bdyvp0",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_DIFFERENT_ISSUE_FEEDBACK_MODAL] = "zazp4x",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_MISSING_ITEM_MODAL] = "lqlxqs",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_NEGATIVE_FEEDBACK_MODAL] = "bnwrzw",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_ORDER_RATING] = "d14pme",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_REFERRAL_CODE] = "gt903u",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_POSITIVE_FEEDBACK_MODAL] = "mfj0kx",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_QUALITY_ISSUE_MODAL] = "dex0p9",
    _a[ZappEventName_1.ZappEventName.SUBMITTED_RIDER_TIPS] = "ao1grn",
    _a[ZappEventName_1.ZappEventName.VIEWED_PRODUCT] = "wur27e",
    _a[ZappEventName_1.ZappEventName.ADDED_RECOMMENDED_PRODUCT_TO_CART] = "ikvqal",
    _a[ZappEventName_1.ZappEventName.ADDED_ORDERED_PRODUCT_TO_CART] = "4g0a19",
    _a[ZappEventName_1.ZappEventName.VIEWED_RECOMMENDED_PRODUCT] = "u7ufe3",
    _a[ZappEventName_1.ZappEventName.JUMPED_TO_RECOMMENDED_PRODUCTS] = "f1uzhh",
    _a[ZappEventName_1.ZappEventName.VIEWED_HOME_CAROUSEL] = "t7rx4z",
    _a[ZappEventName_1.ZappEventName.ABANDONED_BASKET] = "2tu8bn",
    _a);
